<template>
  <div v-if="strikedPrice || finalPrice"
    class="PromoPrice border-l-gr-3 text-sm font-bold leading-[1.2] bg-white dark:bg-primary-darker pl-gr-4 pr-gr-5 py-gr-half-5 inline-block shadow-lg z-30 rounded-r-md"
    :class="[
      promo.on_sale || (showIfFree && !this.promo.on_sale)
        ? 'border-red-500 dark:border-red-500'
        : 'border-secondary-200 dark:border-primary-500',
    ]"
  >
    <div v-if="strikedPrice" class="line-through mb-gr-2 text-red-500 dark:text-red-300">
      {{ strikedPrice }}
    </div>
    <div class="font-black dark:text-white">
      {{ finalPrice }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PromoPrice',

    props: {
      promo: {
        type: Object,
        default: () => ({}),
      },
      showIfFree: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      strikedPrice() {
        if (this.showIfFree && !this.promo.on_sale) {
          return this.formatPrice(this.promo.digital_listing_price);
        }
        return this.promo.on_sale
          ? this.formatPrice(this.promo.digital_listing_price)
          : null;
      },

      finalPrice() {
        if (this.showIfFree) {
          if (this.promo.is_selling) {
            return this.formatPrice(this.promo.final_price)
          } else {
            return 'FREE';
          }
        }

        if (this.promo.is_selling) {
          return this.promo.on_sale
            ? this.formatPrice(this.promo.sale_price)
            : this.formatPrice(this.promo.digital_listing_price);
        }
      },
    },

    methods: {
      formatPrice(price) {
        return price?.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        });
      },
    }
  };
</script>

<!-- <style lang="scss" src="./PromoPrice.scss" scoped></style> -->
<style scoped>
  .PromoPrice[class*='absolute']::after {
    content: '';
    @apply block border-gray-900/30 w-0 h-0 absolute top-full -left-gr-3;
    border-width: var(--golden-ratio-2) var(--golden-ratio-half-4);
    border-bottom-color: transparent !important;
    border-left-color: transparent !important;
  }
</style>
